var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderMonthIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3332",
    "data-name": "Group 3332",
    transform: "translate(-453 -88)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_553",
    "data-name": "Ellipse 553",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(453 88)",
    fill: "#272848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3676",
    "data-name": "Path 3676",
    d: "M40.945,7.893V.546A.536.536,0,0,1,41.471,0a7.367,7.367,0,0,1,7.367,7.367.536.536,0,0,1-.546.526ZM32,8.945a7.893,7.893,0,0,1,6.808-7.817.5.5,0,0,1,.559.506V9.471l5.147,5.147a.5.5,0,0,1-.049.76A7.891,7.891,0,0,1,32,8.945Zm17.311.526a.5.5,0,0,1,.506.559,7.866,7.866,0,0,1-2.43,4.68.5.5,0,0,1-.7-.023L41.471,9.471Z",
    transform: "translate(427 94)",
    fill: "#bac7e2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderMonthIcon);
export default __webpack_public_path__ + "static/media/orderMonthIcon.1474d96e5f76e5788d8cb5d9033f2a21.svg";
export { ForwardRef as ReactComponent };